import React, { useState, useEffect, useReducer } from "react";
import { dataFetchReducer } from "../../../Utils/requestUtils";
import axios from "axios";
import { checkNested, getProperMetadata, getIndicatorsFlagIcon } from "../../utils/utils";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";
import ValidatedImage from "../../utils/ValidatedImage"
import SelfiesDialog from "./SelfiesDialog";


const getStatus = (status, ratioColor) => {
    switch (status) {
        case "pending":
        case "in_manual_analysis":
            return (<span style={{ color: ratioColor }}>Pendente</span>)
        case "manually_approved":
            return (<span style={{ color: '#73C580' }}>Aprovado Manualmente</span>)
        case "automatically_approved":
            return (<span style={{ color: '#73C580' }}>Aprovado Automaticamente</span>)
        case "manually_reproved":
            return (<span style={{ color: '#D91A1A' }}>Reprovado Manualmente</span>)
        case "automatically_reproved":
            return (<span style={{ color: '#D91A1A' }}>Reprovado Automaticamente</span>)
        case "automatically_challenged":
            return (<span style={{ color: '#DDBB08' }}>Contestado Automaticamente</span>)
        case "manually_challenged":
            return (<span style={{ color: '#DDBB08' }}>Contestado Manualmente</span>)
        case "on_hold":
            return (<span style={{ color: '#F5AF2F' }}>Em Espera</span>)
        default:
            return (<span style={{ color: ratioColor }}>{status}</span>)
    }
}

function ClientProfile(props) {
    const decision_metadata = getProperMetadata(props.registration_data_validation.analysis_status_events);
    const { t } = useTranslation();

    const [selfiesShowDialog, setShowSelfiesDialog] = useState(false)
    const [challengeImagekeys, dispatchChallengeImagekeys] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    const [baseRegistrationImage, dispatchBaseRegistrationImage] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )
    const companyKey = props.registration_data_validation?.company_key
    const faceRegistrationKey = props.registration_data_validation?.event_data?.face?.registration_key
    useEffect(() => {
        if (faceRegistrationKey) {
            dispatchChallengeImagekeys({ type: "data_fetch_init" })
            const timer = setTimeout(() => {
                axios.get(`/dash/face_recognition/registration/${faceRegistrationKey}/challenge_images?company_key=${companyKey}`).then(response => {
                    dispatchChallengeImagekeys({
                        type: "data_fetch_success",
                        payload: response.data?.challenge_images
                    })
                }).catch(error => {
                    if ((error.response || {}).status === 403) dispatchChallengeImagekeys({ type: "data_fetch_failure_403" })
                    else if ((error.response || {}).status === 404) dispatchChallengeImagekeys({ type: "data_fetch_failure_404" })
                    else dispatchChallengeImagekeys({ type: "data_fetch_failure" })
                })
            }, 500);
            return () => {
                clearTimeout(timer)
            }
        }
    }, [faceRegistrationKey, companyKey])

    const documentNumber = props.registration_data_validation.event_data.document_number
    useEffect(() => {
        if (documentNumber) {
            dispatchBaseRegistrationImage({ type: "data_fetch_init" })
            const timer = setTimeout(() => {
                axios.get(`/dash/face_recognition/registration/document_number/${documentNumber}?sort=asc`).then(response => {
                    dispatchBaseRegistrationImage({
                        type: "data_fetch_success",
                        payload: response.data
                    })
                }).catch(error => {
                    if ((error.response || {}).status === 403) dispatchBaseRegistrationImage({ type: "data_fetch_failure_403" })
                    else if ((error.response || {}).status === 404) dispatchBaseRegistrationImage({ type: "data_fetch_failure_404" })
                    else dispatchBaseRegistrationImage({ type: "data_fetch_failure" })
                })
            }, 500);
            return () => {
                clearTimeout(timer)
            }
        }
    }, [documentNumber])

    return (
        <div className="analysisCard" style={{ height: "100%" }}>
            <div style={{ marginBottom: 12 }} className={["blueText", "subtitleSize"].join(" ")}>{t("onboarding_data")} - CPF: {props.registration_data_validation.event_data.document_number}</div>
            <div style={{ width: '100%', marginTop: 24 }}>
                <div className={["blueText", "subtitleSize"].join(" ")}>Resumo</div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", margin: "15px 5px", padding: '5px auto' }}>
                    <div className={["normalText", "normalMediumSize"].join(" ")}>
                        Status: {getStatus(props.registration_data_validation?.analysis_status, '#0b1f82')}
                    </div>
                    {
                        decision_metadata.reason ?
                            <div className={["normalText", "normalMediumSize"].join(" ")}>
                                Razão: {decision_metadata.reason_description || decision_metadata.reason}
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {checkNested(props.registration_data_validation, "event_data", "face", "registration_key") &&
                <div style={{ display: 'flex', flexDirection: 'row', width: "100%", marginTop: 24, justifyContent: 'space-evenly' }}>
                    {baseRegistrationImage?.fetchedData?.image?.image_key && <div style={{ width: '35%', maxWidth: "296px" }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8, marginTop: 0 }} className={["blueText", "textSize"].join(" ")}>{t('base_selfie')}</div>
                        <ClientSelfieComponent registration_key={baseRegistrationImage.fetchedData.image?.image_key} />
                    </div>
                    }
                    <div style={{ width: '35%', maxWidth: "296px" }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8, marginTop: 0 }} className={["blueText", "textSize"].join(" ")}>{t('client_selfie')}</div>
                        <ClientSelfieComponent face_match={decision_metadata.face_match} fraud_face={decision_metadata.fraud_face} one_to_one_face_match={decision_metadata['1to1_face_match']} registration_key={props.registration_data_validation.event_data.face.registration_key} />
                        {(challengeImagekeys.fetchedData || []).length > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8, marginTop: 20 }} className={["blueText", "textSize", "link"].join(" ")} onClick={() => { setShowSelfiesDialog(true) }}>{t('see_other_selfies')}</div>}
                    </div>
                </div>
            }
            <SelfiesDialog onClose={() => { setShowSelfiesDialog(false) }} open={selfiesShowDialog} image_list={challengeImagekeys.fetchedData || []} />
        </div>
    );
}

export default ClientProfile;



function ClientSelfieComponent(props) {
    const fraud_face = props?.fraud_face;
    const face_match = props?.face_match;
    const one_to_one_face_match = props?.one_to_one_face_match
    const fraud_face_match = props?.fraud_face_match;
    const registration_key = props?.registration_key;
    const validator_face_match_on_database = props?.validator_face_match_on_database;

    const translateRecomendation = (enumerator) => {
        switch (enumerator) {
            case 'manual_analysis':
                return ' (inconclusivo)'
            case 'new_capture':
                return ' (inconclusivo)'
            case 'reprove':
                return ' (recomenda-se reprovar)'
            case 'proceed_with_caution':
                return ' (recomenda-se prosseguir com cautela)'
            case 'approve':
                return ' (recomenda-se aprovar)'
            default:
                return ''
        }
    }

    if (!fraud_face && !face_match && !fraud_face_match && !validator_face_match_on_database && !one_to_one_face_match) {
        return (
            <ValidatedImage
                image_key={registration_key}
                dash_api_endpoint_url="/dash/face_recognition/image"
                imageStyle={{ margin: "auto", maxWidth: "100%", maxHeight: "100%", borderRadius: "5px", objectFit: "contain" }}
                imageAlt={"client selfie"}
            />
        )
    }

    return (
        <>
            <ValidatedImage
                image_key={registration_key}
                dash_api_endpoint_url="/dash/face_recognition/image"
                imageStyle={{ margin: "auto", maxWidth: "100%", maxHeight: "100%", borderRadius: "5px", objectFit: "contain" }}
                imageAlt={"client selfie"}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '16px' }}>
                {fraud_face?.flag ?
                    <Tooltip placement="right" title={fraud_face.description}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: 'fit-content' }}>{getIndicatorsFlagIcon(fraud_face.flag, 0)} <div style={{ color: '#0b1f82' }}>Prova de vida</div></div>
                    </Tooltip>
                    : <></>
                }
                {face_match?.flag ?
                    <Tooltip placement="right" title={face_match.description}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: 'fit-content' }}>{getIndicatorsFlagIcon(face_match.flag, 0)} <div style={{ color: '#0b1f82' }}>Validação de rosto com foto do documento</div></div>
                    </Tooltip>
                    : <></>
                }
                {fraud_face_match?.flag ?
                    <Tooltip placement="right" title={fraud_face_match.description}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: 'fit-content' }}>{getIndicatorsFlagIcon(fraud_face_match.flag, 0)} <div style={{ color: '#0b1f82' }}>Validação em base de fraudadores</div></div>
                    </Tooltip>
                    : <></>
                }
                {validator_face_match_on_database?.recommendation ?
                    <Tooltip placement="right" title={validator_face_match_on_database.face_match_available ? ('Face do CPF fornecido encontrada na base de rostos. Similaridade com a foto capturada: ' + (validator_face_match_on_database.face_match_score || 0).toFixed(2).replace('.', ',') + '%') : ('Face do CPF fornecido não encontrada na base de rostos')}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: 'fit-content' }}>
                            {getIndicatorsFlagIcon(validator_face_match_on_database.face_match_available ? validator_face_match_on_database.recommendation === 'approve' ? 'positive' : 'negative' : 'neutral', 0)}
                            <div style={{ color: '#0b1f82' }}>Validação em base de rostos {translateRecomendation(validator_face_match_on_database?.recommendation)}</div>
                        </div>
                    </Tooltip>
                    : <></>
                }
                {one_to_one_face_match.flag ?
                    <Tooltip placement="right" title={one_to_one_face_match.description}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: 'fit-content' }}>{getIndicatorsFlagIcon(one_to_one_face_match.flag, 0)} <div style={{ color: '#0b1f82' }}>Validação 1:1</div></div>
                    </Tooltip>
                    : <></>
                }
            </div>
        </>
    );
}